import { useEffect, useState } from "react";
import { useFetch } from "../../utils/useFetch";
import { getQuery } from "../../utils/Url";
import FetchOptions from "../../utils/FetchOptions";
import { useTranslation } from "react-i18next";

export default function useFitbit(refresh) {
    const { t } = useTranslation();
    const [fitbitConnectionInfo, setFitbitConnectionInfo] = useState(null);
    const { apiPost, apiGet, ApiErrors } = useFetch();
    const [isConnecting, setIsConnecting] = useState(false);
    const [fitbitApiError, setFitbitApiError] = useState(null);
    const query = getQuery();

    async function connect(returnUrlQueryString) {
        setIsConnecting(true);
        window.location =
            FetchOptions.apiUrl +
            "/fitbit/connect?ReturnUrl=" +
            encodeURIComponent(
                `${window.location.protocol}//${window.location.host}${window.location.pathname}${
                    returnUrlQueryString ? `?${returnUrlQueryString}` : ""
                }`,
            );
    }

    async function disconnect() {
        const response = await apiPost("/fitbit/disconnect");
        if (response.isOk) await getFitbitStatus();
    }

    async function getFitbitStatus() {
        const response = await apiGet("/fitbit/get-state");
        if (response.isOk) {
            setFitbitConnectionInfo(response.json || {});
        }
    }

    useEffect(() => {
        getFitbitStatus();

        const fitbitErrorCode = query.get("fitbit-error");
        if (fitbitErrorCode !== null) {
            switch (fitbitErrorCode) {
                case "get-consent":
                    setFitbitApiError(t("extConnectors.Error.GetConsent"));
                    break;
                default:
                    break;
            }
        }
    }, [refresh]); // eslint-disable-line

    return {
        fitbitConnectionInfo,
        connect,
        disconnect,
        isConnecting,
        ApiErrors,
        fitbitApiError,
    };
}
